import { useEffect } from 'react'

import { useAuthStore } from '@/stores/authStore'

import { syncPushSubscription } from '../services/pushService'

/**
 * Após login/restauração de sessão, reenvia a inscrição de push existente para
 * ligar o aparelho ao usuário atual. Depende do id do usuário (não do token)
 * para não repetir a cada renovação proativa do access token.
 */
export function usePushSubscriptionSync(): void {
  const userId = useAuthStore((state) => state.user?.id)

  useEffect(() => {
    if (userId == null) return
    syncPushSubscription().catch((error: unknown) => {
      console.warn('[push] falha ao ressincronizar a inscrição', error)
    })
  }, [userId])
}
